import React, { Component } from 'react'
import '../styles/FarmerFinancialTransactions.css'
import deleteIcon from '../images/trash_green.png'
import addIcon from '../images/plus_green.png'
import deleteIconGray from '../images/trash_gray.png'
import addIconGray from '../images/plus_gray.png'
import DropdownWidget from '../widgets/DropdownWidget'
import AlertMessage from '../widgets/AlertMessage'
import ActivityIndicator from '../widgets/ActivityIndicator'
import OrgFooter from '../widgets/OrgFooter'
import APIFarmerRequest from '../api/APIFarmerRequest'
import DatePicker from '../widgets/DatePicker'
import SwitchWidget from '../widgets/SwitchWidget'

class FarmerFinancialTransactions extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			user: JSON.parse(sessionStorage.getItem("user")),
			farmerID: props.id,
			scrollable: false,
			transactions: [],
			ftItemObj: {},
			ftKeyTracer: 0,
			ftListItems: [],
			transacData: {},
			deleteTransacData: {},
			showActivityIndicator: true
		}
		this.setTransactions = this.setTransactions.bind(this)
		this.eventHandler = this.eventHandler.bind(this)
		this.onSubmit = this.onSubmit.bind(this)
		console.log('siteId', this.state.siteId)
		this.getAllFarmerFinancialTransactionsByFarmerId = this.getAllFarmerFinancialTransactionsByFarmerId.bind(this)
	}

	onSubmit() {
		this.setState({showActivityIndicator: true})
		const loanTrans = []
		const addLoanTrans = []
		Object.values(this.state.transacData).forEach((v) => {
			if(v.loan_trans_id != null) {
				loanTrans.push(v)
			}
			else {
				addLoanTrans.push(v)
			}
		})
		const deleteLoanTrans = []
		Object.values(this.state.deleteTransacData).forEach((v) => {
			deleteLoanTrans.push(v)
		})

		console.log("loanTrans -->", loanTrans)
		console.log("addLoanTrans -->", addLoanTrans)
		console.log("deleteLoanTrans -->", deleteLoanTrans)

		const data = {}
		if(this.state.hasFinancialTransaction == false || this.state.hasFinancialTransaction == null) {
			data['farmerFinancialTransaction'] = addLoanTrans
		}
		else {
			if(loanTrans.length > 0) {
				data['farmerFinancialTransaction'] = loanTrans
			}
			if(addLoanTrans.length > 0) {
				data['add'] = {}
				data['add']['farmerFinancialTransaction'] = addLoanTrans
			}
			if(deleteLoanTrans.length > 0) {
				data['delete'] = {}
				data['delete']['farmerFinancialTransaction'] = deleteLoanTrans
			}
		}
		console.log('submit data -->', data)
		if(this.state.hasFinancialTransaction == false || this.state.hasFinancialTransaction == null) {
			console.log("addFarmerFinancialTransaction")
			const apiReq = APIFarmerRequest.addFarmerFinancialTransaction(this.state.accessToken, data)
			apiReq.then((response) => {
				console.log(response)
				if(response.status !== "SUCCESS") {
					this.setState({
						showWarningMessage: true,
						aMessage: response.status + "! " + response.description + ": " + response.results,
						showActivityIndicator: false
					})
					return
				}
				this.setState({
					showInfoMessage: true,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false,
					transacData: {},
					deleteTransacData: {}
				})
			})
		}
		else {
			console.log("editFarmerFinancialTransaction")
			const apiReq = APIFarmerRequest.editFarmerFinancialTransaction(this.state.accessToken, data)
			apiReq.then((response) => {
				console.log(response)
				if(response.status !== "SUCCESS") {
					this.setState({
						showWarningMessage: true,
						aMessage: response.status + "! " + response.description + ": " + response.results,
						showActivityIndicator: false
					})
					return
				}
				this.setState({
					showInfoMessage: true,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false,
					transacData: {},
					deleteTransacData: {}
				})
			})

		}

	}
	
	componentWillMount() {
		if(this.props.id != null) {
			const farmer = APIFarmerRequest.getFarmerDetailsById(this.state.accessToken, parseInt(this.props.id))
			farmer.then((response) => {
				const classifications = APIFarmerRequest.getRegistrantClassificationById(this.state.accessToken, response.results.farmerRegistration.classification_id);
				classifications.then((rc) => {
					this.setState({
						registrationNumber: response.results.farmerRegistration.registration_no,
						firstName:  response.results.farmerBasicInfo.first_name,
						middleName:  response.results.farmerBasicInfo.middle_name,
						lastName:  response.results.farmerBasicInfo.last_name,
						extName:  response.results.farmerBasicInfo.extension_name,
						classification: rc.results.name
					})
				});
			})
			this.getAllFarmerFinancialTransactionsByFarmerId()
		}
	}

	componentDidMount() {
		// this.setTransactions()
	}

	setTransactions(data) {
		const transactions = []
		let hasFT = false
		if(data != null) {
			hasFT = true
			for(const v of data) {
				const ftKey = "ft-" + this.state.ftKeyTracer
				this.state.ftItemObj[ftKey] = <Transaction data={v} farmerID={this.state.farmerID} handler={this.eventHandler}
					disabled={this.state.isViewDetails}  key={ftKey} id={ftKey} />
				this.state.ftKeyTracer++
			}
			const ftKey = "ft-" + this.state.ftKeyTracer
			this.state.ftItemObj[ftKey] = <Transaction farmerID={this.state.farmerID} handler={this.eventHandler}
				disabled={this.state.isViewDetails} key={ftKey} id={ftKey} />
			this.state.ftKeyTracer++
			Object.keys(this.state.ftItemObj).forEach((k => {
				transactions.push(this.state.ftItemObj[k])
			}))
		}
		else {
			const ftKey = "ft-" + this.state.ftKeyTracer
			this.state.ftItemObj[ftKey] = <Transaction farmerID={this.state.farmerID}
				handler={this.eventHandler} key={ftKey} id={ftKey} />
			this.state.ftKeyTracer++
			transactions.push(this.state.ftItemObj[ftKey])
		}
		this.setState({
			transactions: transactions,
			showActivityIndicator: false,
			hasFinancialTransaction: hasFT
		})
	}

	getAllFarmerFinancialTransactionsByFarmerId() {
		const apiResponse = APIFarmerRequest.getAllFarmerFinancialTransactionsByFarmerId(this.state.accessToken, this.state.farmerID)
		apiResponse.then((response) => {
			if(response.status === "FAILED") {
				this.setTransactions()
				this.setState({showActivityIndicator: false})
				return
			}
			this.setTransactions(response.results.rows)
		})
	}

	eventHandler(e, compId, key, value) {
		switch(e) {
			case "transaction":
				this.state.transacData[compId] = value
				break
			case "add":
				this.state.transacData[compId] = value
				const added = []
				const ftKey = "ft-" + this.state.ftKeyTracer
				this.state.ftItemObj[ftKey] = <Transaction handler={this.eventHandler} key={ftKey} id={ftKey} />
				this.state.ftKeyTracer++
				this.state.ftListItems.push(this.state.ftItemObj[ftKey])
				Object.keys(this.state.ftItemObj).forEach((k => {
					added.push(this.state.ftItemObj[k])
				}))
				this.setState({transactions: added})
				break
			case "delete":
				this.state.deleteTransacData[compId] = value
				delete this.state.ftItemObj[compId]
				const deleted = []
				Object.keys(this.state.ftItemObj).forEach((k => {
					deleted.push(this.state.ftItemObj[k])
				}))
				this.setState({transactions: deleted})
		}
	}

	render() {
		const view = <div id="financial-transactions">
			<div id="ft-scroll-area"><div id="ft-client-area">
				<div id="ft-cell1">
					<div id="ft-cell1-r1-i1">
						<div>Registration Number</div>
						<input type="text" value={this.state.registrationNumber} disabled="true" />
					</div>
					<div id="ft-cell1-r1-i2">
						<div>Full Name</div>
						<div id="ft-cell1-r1-i2-val">
							<input type="text" value={this.state.firstName} style={{'flex-basis': "31%"}} disabled="true" />
							<input type="text" value={this.state.middleName} style={{'flex-basis': "31%"}} disabled="true" />
							<input type="text" value={this.state.lastName} style={{'flex-basis': "31%"}} disabled="true" />
							<input type="text" value={this.state.extname} style={{'flex-basis': "7%"}} disabled="true" />
						</div>
					</div>
					<div id="ft-cell1-r1-i3">
						<div>Classification</div>
						<input type="text" value={this.state.classification} disabled="true" />
					</div>
				</div>
				<div className="title-bar">TRANSACTIONS</div>
				<div id="ft-cell2">
					{this.state.transactions}
				</div>
			</div>
			</div>
			<div className="alternate-footer"><OrgFooter submit={this.onSubmit}
				showSubmit={(this.state.user.role_id == 3)? true: false} disabled={this.state.isViewDetails} /></div>
			{this.state.showInfoMessage == true && <AlertMessage type="information" text={this.state.aMessage}
				onClick={() => { this.setState({showInfoMessage: false}) }} />}
			{this.state.showWarningMessage == true && <AlertMessage type="warning" text={this.state.aMessage}
				onClick={() => { this.setState({showWarningMessage: false}) }} />}
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>
		return(view)
	}
}

class Transaction extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			siteId: localStorage.getItem("siteId"),
			itemId: props.id,
			transaction: {farmer_id: props.farmerID},
			disabled: props.disabled,
			provider: '-- SELECT --',
			loanSource: '-- SELECT --',
			loanType: '-- SELECT --',
			loanStatus: '-- SELECT --',
			crop: '-- SELECT --',
			sources: [
				{id: 1, name: 'AGRI-CREDIT'},
				{id: 2, name: 'MICROFINANCE'},
				{id: 0, name: 'ADD OTHER SOURCE'},
			],
			statuses: [
				{id: 1, name: 'CURRENT'},
				{id: 2, name: 'PAST DUE, ENTER REASON MANUALLY'},
				{id: 1, name: 'FULLY PAID'},
				{id: 1, name: 'RESTRUCTURE'},
			],
			financialSource: [
				{id: 0, name: 'OTHER FINANCIAL SOURCE'}
			]
		}
		this.onAddItemClick = this.onAddItemClick.bind(this)
		this.onDeleteItem = this.onDeleteItem.bind(this)
		this.getAllLoanProviderBySiteId = this.getAllLoanProviderBySiteId.bind(this)
		this.getAllCrops = this.getAllCrops.bind(this)
		this.getAllLoanSources = this.getAllLoanSources.bind(this)
		this.getAllLoanStatuses = this.getAllLoanStatuses.bind(this)
		this.getAllLoanTypes = this.getAllLoanTypes.bind(this)
	}

	async componentWillMount() {
		let siteId = await localStorage.getItem("siteId")
		this.getAllLoanProviderBySiteId()
		this.getAllCrops()
		this.getAllLoanSources()
		this.getAllLoanTypes()
		this.getAllLoanStatuses()
	}

	componentDidMount() {
		if(this.props.data != null) {
			console.log(this.props.data)
			this.state.transaction["loan_trans_id"] = this.props.data.loan_trans_id
			if(this.state.disabled) {
				var addDeleteButton = <img src={deleteIcon} className="delete-icon" alt="DELETE" />
			}
			else {
				addDeleteButton = <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />
			}
			const amount = this.props.data.amount_availed + ""
			this.setState({
				// transaction: {},
				addDeleteButton: addDeleteButton,
				provider: this.props.data.loan_provider_name.toUpperCase(),
				loanSource:  this.props.data.loan_source_name.toUpperCase(),
				loanType: this.props.data.loan_type_name,
				loanStatus:  this.props.data.loan_status_name,
				crop: '-- SELECT --',
				dateOfRelease: this.props.data.release_date,
				dueDate: this.props.data.due_date,
				amount: amount.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
				isInsured: (this.props.data.is_crop_insured == 1)? true: false
			})
			return
		}
		if(this.state.disabled) {
			this.setState({addDeleteButton: <img src={addIcon} className="add-icon" alt="ADD" />})
			return
		}
		this.setState({addDeleteButton: <img src={addIcon} className="add-icon" alt="ADD" onClick={this.onAddItemClick} />})
	}

	getAllLoanProviderBySiteId() {
		const farmer = APIFarmerRequest.getAllLoanProviderBySiteId(this.state.accessToken, this.state.siteId)
		farmer.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.loan_provider_id, name: v.loan_provider_name.toUpperCase()})
			}
			c.push({id: 0, name: 'OTHER FINANCIAL SOURCE'})
			this.setState({loanProviders: c})
		})
	}

	getAllLoanSources() {
		const resp = APIFarmerRequest.getAllLoanSources(this.state.accessToken)
		resp.then((rc) => {
			if(rc.status === "FAILED") {
				return
			}
			const c = []
			for(const v of rc.results.rows) {
				c.push({id: v.loan_source_id, name: v.name.toUpperCase()})
			}
			c.push({id: 0, name: 'OTHER FINANCIAL SOURCE'})
			this.setState({loanSources: c})
		})
	}

	getAllLoanTypes() {
		const resp = APIFarmerRequest.getAllLoanTypes(this.state.accessToken)
		resp.then((rc) => {
			if(rc.status === "FAILED") {
				return
			}
			const c = []
			for(const v of rc.results.rows) {
				c.push({id: v.loan_type_id, name: v.name.toUpperCase()})
			}
			this.setState({loanTypes: c})
		})
	}

	getAllLoanStatuses() {
		const resp = APIFarmerRequest.getAllLoanStatuses(this.state.accessToken)
		resp.then((rc) => {
			if(rc.status === "FAILED") {
				return
			}
			const c = []
			for(const v of rc.results.rows) {
				c.push({id: v.loan_status_id, name: v.name.toUpperCase()})
			}
			this.setState({loanStatuses: c})
		})
	}

	getAllCrops() {
		const resp = APIFarmerRequest.getAllCrops(this.state.accessToken)
		resp.then((rc) => {
			if(rc.status === "FAILED") {
				return
			}
			const c = []
			for(const v of rc.results.rows) {
				c.push({id: v.crop_id, name: v.name})
				if(this.props.data != null) {
					if(v.crop_id === this.props.data.crop_id) {
						var crop = v.name
					}
				}
			}
			this.setState({crops: c, crop: crop? crop: '-- SELECT --'})
		})
	}

	onAddItemClick() {
		this.props.handler("add", this.state.itemId, null, this.state.transaction)
		this.setState({addDeleteButton: <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />})
	}

	onDeleteItem() {
		// const name = this.state.financing["name"]? this.state.financing["name"]: this.state.name
		this.setState({
			showConfirmMessage: true,
			aMessage: `Are you sure you want to remove transaction with ${this.state.provider}?`
		})
	}

	render() {
		const view = <div className="transaction">
			<div>{this.state.addDeleteButton}</div>
			<div className="transaction-inputs">
				<div className="transaction-cell1">
					<div className="transaction-cell1-r1-i1">
						<div>Name of Financial Source</div>
						<DropdownWidget list={this.state.loanProviders} placeholder={this.state.provider} cStyle={{"width": "100%"}}
							onItemSelected={async (id, val) => {
								console.log('provider', id, val)
								if(id == 0) {
									const user = await JSON.parse(sessionStorage.getItem("user"))
									var provinceId = user.province_id
								}
								this.state.transaction["loan_provider_id"] = id
								this.props.handler("transaction", this.state.itemId, null, this.state.transaction)
								if(this.state.addDeleteButton.props.alt == "ADD") {
									this.onAddItemClick()
								}
								this.setState({
									providerId: id,
									provinceId: provinceId
								})
							}} disabled={this.state.disabled} />
						{this.state.providerId == 0 && <div className="transaction-cell1-r1-i1">
							<input type='text' style={{"width": "calc(100% + 10px)"}} onChange={(e) => {
								this.state.transaction["loan_provider_id"] = {
									"site_id": this.state.siteId,
									"province_id": this.state.provinceId,
									"loan_provider_name": e.target.value
								}
								console.log(this.state.transaction)
								this.props.handler("transaction", this.state.itemId, null, this.state.transaction)
								if(this.state.addDeleteButton.props.alt == "ADD") {
									this.onAddItemClick()
								}
							}} disabled={this.state.disabled} />
						</div>}
					</div>
					<div className="transaction-cell1-r1-i2">
						<div>Source of Fund</div>
						<DropdownWidget list={this.state.loanSources} placeholder={this.state.loanSource} cStyle={{"width": "100%"}}
							onItemSelected={(id, val) => {
								this.state.transaction["loan_source_id"] = (id == 0)? null: id
								this.props.handler("transaction", this.state.itemId, null, this.state.transaction)
								if(this.state.addDeleteButton.props.alt == "ADD") {
									this.onAddItemClick()
								}
								this.setState({sourceId: id})
							}} disabled={this.state.disabled} />
						{this.state.sourceId == 0 && <div className="transaction-cell1-r1-i2">
							<input type='text' style={{"width": "calc(100% + 10px)"}} onChange={(e) => {
								this.state.transaction["loan_source_id"] = {name: e.target.value}
								this.props.handler("transaction", this.state.itemId, null, this.state.transaction)
								if(this.state.addDeleteButton.props.alt == "ADD") {
									this.onAddItemClick()
								}
							}} disabled={this.state.disabled} />
						</div>}
					</div>
					<div className="transaction-cell1-r1-i3">
						<div>Loan Type</div>
						<DropdownWidget list={this.state.loanTypes} placeholder={this.state.loanType} cStyle={{"width": "100%"}}
							onItemSelected={(id, val) => {
								this.state.transaction["loan_type_id"] = id
								this.props.handler("transaction", this.state.itemId, null, this.state.transaction)
								if(this.state.addDeleteButton.props.alt == "ADD") {
									this.onAddItemClick()
								}
							}} disabled={this.state.disabled} />
					</div>
				</div>
				<div className="transaction-cell2">
					<div className="transaction-cell1-r2-i1">
						<div>Amount Availed</div>
						<input className="amount" type="text" value={this.state.amount} placeholder='0.0' onChange={(e) =>{
							if(isCurrencyValid(e.target.value)) {
								const v = e.target.value.replace(/,/g, "")
								this.setState({amount: v})
								e.target.value = formatCurrency(e.target.value)
								this.state.transaction["amount_availed"] = v
								this.props.handler("transaction", this.state.itemId, null, this.state.transaction)
							}
							else {
								if(isNaN(parseInt(e.target.value))) {
									e.target.value = ""
								}
								else {
									const v = e.target.value.replace(/,/g, "")
									e.target.value = parseInt(v)
									e.target.value = e.target.value.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
								}
							}
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
						}} disabled={this.state.disabled} />
					</div>
					<div className="transaction-cell1-r2-i2">
						<div>Date of Release</div>
						<DatePicker className="amount" value={this.state.dateOfRelease} onChange={(value) =>{
							this.state.transaction["release_date"] = value
							this.props.handler("transaction", this.state.itemId, null, this.state.transaction)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
						}} disabled={this.state.disabled} />
					</div>
					<div className="transaction-cell1-r2-i3">
						<div>Due Date</div>
						<DatePicker className="amount" value={this.state.dueDate} onChange={(value) =>{
							this.state.transaction["due_date"] = value
							this.props.handler("transaction", this.state.itemId, null, this.state.transaction)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
						}} disabled={this.state.disabled} />
					</div>
					<div className="transaction-cell1-r2-i4">
						<div>Crop Involved</div>
						<DropdownWidget list={this.state.crops} placeholder={this.state.crop} cStyle={{"width": "100%"}}
							onItemSelected={(id, val) => {
								this.state.transaction["crop_id"] = id
								this.props.handler("transaction", this.state.itemId, null, this.state.transaction)
								if(this.state.addDeleteButton.props.alt == "ADD") {
									this.onAddItemClick()
								}
							}} disabled={this.state.disabled} />
					</div>
					<div className="transaction-cell1-r2-i5">
						<div>
							<SwitchWidget isOn={this.state.isInsured} onToggle={(v) => {
								this.state.transaction["is_crop_insured"] = v? 1: 0
								this.props.handler("transaction", this.state.itemId, null, this.state.transaction)
								this.setState({isInsured: v})
							}} isDisabled={this.state.disabled} />
						</div>
						<div style={{'margin-left': '10px'}}>Is the crop insured?</div>
					</div>
				</div>
				<div className="transaction-cell2">
					<div className="transaction-cell1-r2-i4">
						<div>Status of Loan</div>
						<DropdownWidget list={this.state.loanStatuses} placeholder={this.state.loanStatus} cStyle={{"width": "100%"}}
							onItemSelected={(id, val) => {
								this.state.transaction["loan_status_id"] = id
								this.props.handler("transaction", this.state.itemId, null, this.state.transaction)
								if(this.state.addDeleteButton.props.alt == "ADD") {
									this.onAddItemClick()
								}
							}} disabled={this.state.disabled} />
					</div>
				</div>

			</div>
			{this.state.showConfirmMessage == true && <AlertMessage type="confirmation" text={this.state.aMessage}
			onClick={(e) => {
				this.setState({showConfirmMessage: false})
				if(e.target.innerHTML === "NO") {
				}
				else {
					this.props.handler("delete", this.state.itemId, null, this.state.transaction)
				}
			}} />}
		</div>
		return(view)
	}
}

const formatCurrency = (value) => {
	const v = value.replace(/,/g, "")
	const c = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
	return(c)
}

const isCurrencyValid = (value) => {
	const checker = /^[\d,]+\.?\d{0,2}?$/
	const isValid = checker.test(value)
	return(isValid)
}

export default FarmerFinancialTransactions
